'use client';
import { HTMLAttributes, PropsWithChildren, useState } from 'react';
import dynamic from 'next/dynamic';
import { clsx } from 'clsx';
import {
  FullTestimonialPopup,
} from '@/components/pages/TestimonialsPage/Testimonials/TestimonialItem/FullTestimonialPopup/FullTestimonialPopup';
import { ITestimonialItem } from '@/api/testimonials/testimonials.types';
import s from './ShowMoreButtonWrapper.module.scss';

const Modal = dynamic(() => import('@/components/layouts/Modal/Modal'), { ssr: false });

interface Props extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  testimonial: ITestimonialItem;
}

export const ShowMoreButtonWrapper = ({ testimonial, className }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => setIsOpen(false);

  return (
    <>
      <div className={clsx(s.wrapper, className)} onClick={() => setIsOpen(true)}>
        <button className={s.wrapper__showMore} type={'button'}>Подробнее</button>
      </div>
      <Modal isOpen={isOpen} onClose={closeModal}>
        <FullTestimonialPopup testimonial={testimonial} />
      </Modal>
    </>
  );
};